export { SORT_TYPES } from './sortTypes';

export const W9_TRACKING_COLUMNS = [
  { id: 'event_name', label: 'Event', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'event_date', label: 'Event Date', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'venue_name', label: 'Venue', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'has_w9', label: 'W-9 On File', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'w9_count', label: 'W-9 Attachments', alwaysVisible: false, defaultVisible: true, sortable: false },
];

export const getDefaultVisibleColumns = () =>
  W9_TRACKING_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  W9_TRACKING_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
